import httpApi from '../api/httpApi';
import useSWR from 'swr';

const UNITS_URL = '/api/v1/offers/units';

const useQuotationsUnitsSWR = () => {
    const fetch = (query): Promise<string[]> => {
        return httpApi
            .get<{ units: string[] }>(query)
            .then((res) => {
                return res.getData().units;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading } = useSWR(UNITS_URL, fetch, {
        errorRetryCount: 1,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });

    return {
        units: data ? data : [],
        isLoading: isLoading,
        isError: error,
    };
};

export default useQuotationsUnitsSWR;
